import React from 'react';
import { SelectFilterTypes } from "../common/Helpers";
import {
    Select,
    Stack,
    TextField,
} from '@shopify/polaris';

const propertyOperatorOptions = [
    { label: 'is equal to', value: 'EqualTo' },
    { label: 'is not equal to', value: 'NotEqualTo' },
    { label: 'contains', value: 'Contains' },
    { label: 'does not contain', value: 'DoesNotContain' },
    { label: 'starts with', value: 'StartsWith' },
    { label: 'does not start with', value: 'DoesNotStartWith' },
    { label: 'ends with', value: 'EndsWith' },
    { label: 'does not end with', value: 'DoesNotEndWith' },
];

class ProductFilterComponent extends React.Component {
    state = {};

    render() {

        var options = propertyOperatorOptions;

        return (
            <Stack alignment="center" spacing="tight">
                <Select
                    options={SelectFilterTypes}
                    value={this.props.filter.filterType}
                    onChange={(selected, id) => this.props.onFilterTypeChange(this.props.filter, selected)}
                />
                <Select
                    options={options}
                    value={this.props.filter.operator}
                    onChange={(selected, id) => this.props.onOperatorChange(this.props.filter, selected)}
                />
                {this.createValueInput()}
            </Stack>
        );
    }

    createValueInput() {

        return <TextField
            placeholder="Choose value"
            value={this.props.filter.value}
            onChange={(selected, id) => this.props.onValueChange(this.props.filter, selected)}
        />
    }
}

export default ProductFilterComponent;